import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    "indextitle": {
        "LDDBid": "LDDB id",
        "ProteinId": "Target Proteins",
        "ProteinDescription": "Protein Description",
        "GeneNames": "Gene Name",
        "ProbeId": "Probe ID",
        "Density": "Probe Concentration",
        "ProbeStructImg": "Probe structure",
        "ProbeType": "Probe Type",
        "": "Labeled Sites detail",
        "LigandId": "Competitive Molecule",
        "concentration": "Concentration",
        "CompetitiveRatio": "Competitive ratio (P/PC)",
        "CellLine": "Cell line",
        "Source": "Data source",
        "Species": "Species",
        "EntryName": "Uniprot Entry Name",
        "UniparcID": "Uniparc ID",
        "TddId": "TDD ID",
        "TargType": "TARGTYPE",
        "Synonyms": "SYNONYMS",
        "Function": "FUNCTION",
        "BioClass": "BIOCLASS",
        "TTDDrugID": "TTD Drug ID",
        "TTDDrugName": "TTD Drug Name",
        "TTDDrugGroup": "TTD Drug Group",
        "WikiPath": "WIKIPATH",
        "NetPath": "NET_PATH",
        "IntePath": "INTEPATH",
        "PantPath": "PANTPATH",
        "GoBp": "GO(biological process)",
        "GoCc": "GO(cellular component)",
        "GoMf": "GO(molecular function)",
        "Disease": "Disease",
        "CellularLocation": "Subcellular location",
        "InteractsWith": "Interacts with",
        "ProteinFamilies": "Protein families",
        "KeggPathway": "KEGG Pathway",
        "TargetHierarchy": "Target hierarchy",
        "KeggDrug": "KEGG Drug",
        "DrugBankID": "DrugBank Drug ID",
        "DrugBankName": "DrugBank Drug Name",
        "DrugBankGroups": "DrugBank Drug Groups",
        "DrugCrntralID": "DrugCentral Protein ID",
        "DrugCrntralName": "DrugCentral Drug Name",
        "ChEMBL": "ChEMBL",
        "GuidetoPHARMACOLOGY": "GuidetoPHARMACOLOGY",
        "BindingDB": "BindingDB",
        "IntramembraneInterval": "Intramembrane Interval",
        "IntramembraneDescription": "Intramembrane Description",
        "IntramembraneEvidence": "Intramembrane Evidence",
        "TransmembraneInterval": "Transmembrane Interval",
        "TransmembraneDescription": "Transmembrane Description",
        "TransmembraneEvidence": "Transmembrane Evidence",
        "DomainCCDescription": "Domain [CC] Description",
        "DomainCCEvidence": "Domain [CC] Evidence",
        "DomainFTInterval": "Domain [FT] Interval",
        "DomainFTDescription": "Domain [FT] Description",
        "DomainFTEvidence": "Domain [FT] Evidence"
    },
    "indexbutton": {
        "selectall": "select all",
        "off": "off",
        "save": "save",
        "inputfor": "Please enter your search...",
        "append": "append",
        "search": "search",
        "delete": "delete",
        "selectoption": {
            "ALL": "ALL",
            "LDDBid": "LDDB id",
            "ProteinId": "Target Proteins",
            "Species": "species",
            "ProteinDescription": "Protein Description",
            "GeneNames": "Gene Name",
            "ProbeId": "Probe ID",
            "ProbeType": "Probe type",
            "SitesList": "Labeled Sites",
            "Density": "Concentration",
            "CompetitiveRatio": "Competitive ratio (P/PC)",
            "LigandId": "Competitive Molecule",
            "Source": "Data source"
        }
    },
    "indexwarn": {
        "downwarn": "Please select the data you want to download",
        "downwarntitle": "Warn"
    },
    "button": {
        "advanced_search": "Advanced search",
        "structure_search": "Structure search",
        "structure_pic_search": "Structure picture search",
        "change_password": "Change password",
        "quit": "Quit",
        "Downloadselection": "Download selection",
        "Downloadselecteddata": "Download selected data",
        "Downloadalldata": "Download all data",
        "Download": "Download"
    },
    "tztitle": {
        "concentration": "Concentration",
        "competitiveratio": "Competitive ratio (P/PC)",
        "competing_ligand": "Competing ligand",
        "cell_line": "Cell line",
        "experimental_data_source": "Experimental data source"
    },
    "des": {
        "title": "Target ID&species&Class",
        "entry": "Entry",
        "entry_name": "Entry_name",
        "protein_names": "Protein names",
        "protein_families": "Protein families",
        "target_hierarchy": "Target hierarchy",
        "gene_names": "Gene Names",
        "taxonomy": "taxonomy",
        "goclass": "GO class",
        "goDescription": "GO Description",
        "gono": "GO NO.",
        "cellularlocation": "Cellular Location",
        "KEGGNo": "KEGG No.",
        "KEGGterm": "KEGG term",
        "ActIveSite": "ActIve Site",
        "ActIveType": "Type",
        "ActIvePosition": "Position",
        "ActIveDescription": "Description",
        "3DStructure": "3D Structure",
        "ProbeID": "Probe ID",
        "Structure": "Structure",
        "WarheadType": "Warhead/Type",
        "Labelingsites": "Labeling sites",
        "SOURCE": "SOURCE",
        "ProbeligangList": "Probe & ligang List",
        "AnnotationLocation": "Annotation & Location",
        "logP": "logP",
        "logS": "logS",
        "Heavy Atom Count": "Heavy Atom Count",
        "Ring Count": "Ring Count",
        "Hydrogen Bond Acceptor Count": "Hydrogen Bond Acceptor Count",
        "Hydrogen Bond Donor Count": "Hydrogen Bond Donor Count",
        "Rotatable Bond Count": "Rotatable Bond Count",
        "Topological Polar Surface Area": "Topological Polar Surface Area",
        "solvent accessible surface area": "solvent accessible surface area",
        "DiseaseDrug": "Disease & Drug",
        "Disease": "Disease",
        "MIMNo": "MIM No.",
        "Description": "Description",
        "Evidence": "Evidence",
        "Note": "Note",
        "score": "SCORE",
        "cancelscore": "cancel",
        "targetscreeningmethod": "Target Screening Method",
        "methoddescription": "Method Description",
    },
    "probe": {
        "ProbeID": "Probe ID",
        "TargetProteins": "Target Proteins",
        "species": "species",
        "ProteinDescription": "Protein Description",
        "GeneName": "Gene Name",
        "LabeledSitesDetail": "Labeled Sites Detail",
        "Concentration": "Concentration",
        "ratio": "ratio(P/PC)",
        "competitiveligand": "competitive ligand",
        "cellline": "cell line",
        "datasource": "data source"
    },
    "site": {
        "Targetname": "Target name",
        "Probename": "Probe name",
        "Siteslist": "Sites list",
        "Sitesvisualization": "Sites visualization",
        "datasource": "data source"
    },
    ...enLocale
}
export default en


// WEBPACK FOOTER //
// ./src/common/i18n/en.js